import http from "./axios";

// 查询列表
const queryPage = ({ channel, pageNo, pageSize }) => {
  return http.get("/manager/channelCityFilter/filterPage", {
    channel,
    pageNo,
    pageSize,
  });
};

// 添加
const addData = ({
  channel,
  includeCity,
  excludeCity,
  interfaceParam,
  interfaceName,
  enabled,
  dumpPlatform,
  remark,
  ip,
}) => {
  return http.json_post("/manager/channelCityFilter/addFilter", {
    channel,
    includeCity,
    excludeCity,
    interfaceParam,
    interfaceName,
    enabled,
    dumpPlatform,
    remark,
    ip,
  });
};

const enabledFilter = ({ id, enabled }) => {
  return http.json_post("/manager/channelCityFilter/enabledFilter", {
    id,
    enabled,
  });
};

// 编辑
const editData = ({
  id,
  channel,
  includeCity,
  excludeCity,
  interfaceParam,
  interfaceName,
  enabled,
  dumpPlatform,
  remark,
  ip,
}) => {
  return http.json_post("/manager/channelCityFilter/updateFilter", {
    id,
    channel,
    includeCity,
    excludeCity,
    interfaceParam,
    interfaceName,
    enabled,
    dumpPlatform,
    remark,
    ip,
  });
};

// 删除
const deleteData = ({ id }) => {
  return http.json_post("/manager/channelCityFilter/deleteFilter", {
    id,
  });
};

export default {
  deleteData,
  queryPage,
  addData,
  editData,
  enabledFilter,
};
